import { useHistory } from "react-router-dom";

export type LocationIsIndexState = {
  isIndex?: boolean;
}

const useNavigateBack = () => {
  const history = useHistory<LocationIsIndexState | undefined>();

  const canGoBack = !history.location.state?.isIndex;

  const navigateBack = () => {
    if (canGoBack) {
      history.goBack();
    }
  }

  return {
    navigateBack,
    canGoBack
  }
}

export default useNavigateBack;
